"use strict";

exports.__esModule = true;
exports.DeviceEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _reactFinalForm = require("react-final-form");
var _reactIntl = require("react-intl");
var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _FormGroupField = require("../../Form/FormGroupField");
var _Core = require("../../Core");
var _DeviceDataItemsContext = require("../DeviceDataItemsContext");
var _DeviceTagListContext = require("../../Device/DeviceTagListContext");
var _DeviceDataItemSelector = require("../DeviceDataItemSelector");
var _DeviceTagSelector = require("../DeviceTagSelector");
var _System = require("../../../System");
var _constants = require("../../constants");
var _inputValidation = require("../../../Utils/inputValidation");
var _dec, _dec2, _class, _DeviceEditor;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var DeviceEditorForm = _styledComponents["default"].form.withConfig({
  displayName: "DeviceEditor__DeviceEditorForm",
  componentId: "sc-1bxssgz-0"
})(["display:flex;flex:1;height:100%;flex-direction:column;h3{font-size:22px;margin:0 0 10px 0;}"]);
var EditorBody = _styledComponents["default"].div.withConfig({
  displayName: "DeviceEditor__EditorBody",
  componentId: "sc-1bxssgz-1"
})(["padding:1rem;flex:1;display:flex;flex-direction:column;overflow:auto;"]);
var CheckBoxFormGroupField = (0, _styledComponents["default"])(_FormGroupField.FormGroupField).withConfig({
  displayName: "DeviceEditor__CheckBoxFormGroupField",
  componentId: "sc-1bxssgz-2"
})(["margin:0;.bp6-control{margin:0;}"]);
var EnabledCheckBoxWrapper = (0, _styledComponents["default"])(CheckBoxFormGroupField).withConfig({
  displayName: "DeviceEditor__EnabledCheckBoxWrapper",
  componentId: "sc-1bxssgz-3"
})(["padding:0 1rem 1rem 0rem;"]);

/**
 * Device editor form
 */
var DeviceEditor = exports.DeviceEditor = (_dec = _DeviceTagListContext.DeviceTagListContext.withContext, _dec2 = _DeviceDataItemsContext.DeviceDataItemsContext.withContext, _dec(_class = _dec2(_class = (0, _Core.withTranslator)(_class = (_DeviceEditor = /*#__PURE__*/function (_Component) {
  function DeviceEditor() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.validateName = function (value, allValues, meta) {
      var translator = _this.props.translator;
      var translate = translator.translate;
      if (!value || !value.trim()) {
        return translate("DeviceEditor.validateName.required", "Name is required.");
      }
      if ((0, _inputValidation.isUnmodified)(meta)) {
        return undefined;
      }
      return (0, _inputValidation.translateValidationError)((0, _inputValidation.validateEntityName)(value), translate);
    };
    _this.validateForm = function /** values: DeviceFormData */
    () {
      return {};
    };
    _this.handleSubmit = function (values) {
      var _this$props = _this.props,
        onSubmit = _this$props.onSubmit,
        device = _this$props.device;
      var output = Object.assign({}, device);
      output.enabled = values.enabled;
      output.name = values.name.trim();
      output.allowProducing = values.allowProducing;
      output.tags = values.tags;
      output.currentCycleClassify = values.currentCycleClassify;
      output.performanceParameters = {
        realtimeDataItems: values.realtimeDataItems,
        historicalDataItems: values.historicalDataItems
      };
      onSubmit(output);
    };
    return _this;
  }
  _inheritsLoose(DeviceEditor, _Component);
  var _proto = DeviceEditor.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      device = _this$props2.device,
      deviceTags = _this$props2.deviceTags,
      dataItems = _this$props2.dataItems,
      translate = _this$props2.translator.translate,
      _this$props2$onCancel = _this$props2.onCancelScreenName,
      onCancelScreenName = _this$props2$onCancel === void 0 ? "DeviceList" : _this$props2$onCancel;
    var initialValue = Object.assign({}, device, {
      realtimeDataItems: device.performanceParameters.realtimeDataItems,
      historicalDataItems: device.performanceParameters.historicalDataItems
    });
    var realtimeDataItems = dataItems.filter(function (i) {
      return i.category === _constants.CATEGORY_EVENT || i.category === _constants.CATEGORY_CONDITION || i.category === _constants.CATEGORY_SAMPLE;
    });
    // including representation prop here which is an old mtconnect convention no longer used but leaving in for legacy data support
    var historicalDataItems = dataItems.filter(function (i) {
      return i.category === _constants.CATEGORY_SAMPLE && i.representation !== "TIME_SERIES";
    });
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
      initialValues: Object.assign({}, initialValue),
      validate: this.validateForm,
      onSubmit: this.handleSubmit,
      mutators: Object.assign({}, _finalFormArrays["default"])
    }, function (_ref) {
      var handleSubmit = _ref.handleSubmit,
        pristine = _ref.pristine,
        invalid = _ref.invalid,
        submitting = _ref.submitting;
      return /*#__PURE__*/_react["default"].createElement(DeviceEditorForm, {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.Prompt, {
        when: !pristine && !submitting,
        message: translate("DeviceEditor.form.prompt.message", "Are you sure you want to leave this page without saving your changes?")
      }), /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
        style: {
          marginLeft: "auto"
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        type: "submit",
        icon: _icons.IconNames.FLOPPY_DISK,
        intent: _core.Intent.PRIMARY,
        text: translate("DeviceEditor.saveButton.text", "Save"),
        disabled: pristine || invalid
      }), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
        minimal: true,
        end: true,
        icon: _icons.IconNames.CROSS,
        to: (0, _System.getScreenLocation)(onCancelScreenName),
        text: translate("DeviceEditor.cancelButton.text", "Cancel")
      }))), /*#__PURE__*/_react["default"].createElement(EditorBody, null, /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "name",
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditor.name",
          defaultMessage: "Name"
        }),
        requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null),
        validate: _this2.validateName
      }, function (_ref2) {
        var input = _ref2.input;
        return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, input);
      }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "tags",
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditor.tags",
          defaultMessage: "Groups"
        }),
        helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditor.tags.helperText",
          defaultMessage: "Separate multiple tags with comma"
        })
      }, function (_ref3) {
        var input = _ref3.input;
        return /*#__PURE__*/_react["default"].createElement(_DeviceTagSelector.DeviceTagSelector, {
          shouldAddItemWhenNotInList: function shouldAddItemWhenNotInList(value) {
            return !deviceTags.find(function (tag) {
              return tag === value;
            });
          },
          multiple: true,
          items: deviceTags,
          onSelect: input.onChange,
          onBlur: input.onBlur,
          selected: input.value || [],
          rightIcon: _icons.IconNames.CARET_DOWN,
          minimal: true
        });
      }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "enabled",
        type: "checkbox",
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditor.enable.label",
          defaultMessage: "Device Status"
        })
      }, function (_ref4) {
        var input = _ref4.input;
        return /*#__PURE__*/_react["default"].createElement(_core.Checkbox, _extends({
          label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "DeviceEditor.enable.enabled.label",
            defaultMessage: "Enabled"
          })
        }, input));
      }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        name: "performanceParameters",
        label: /*#__PURE__*/_react["default"].createElement("h3", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditor.performanceParameters",
          defaultMessage: "Historical and Realtime Data Items"
        }))
      }, /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "historicalDataItems",
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditor.historicalDataItems",
          defaultMessage: "Historical"
        })
      }, function (_ref5) {
        var input = _ref5.input;
        return /*#__PURE__*/_react["default"].createElement(_DeviceDataItemSelector.DeviceDataItemSelector, {
          placeholder: translate("DeviceDataItemSelector.placeholder.multiple.historical", "Select Historical Data Items"),
          onSelect: input.onChange,
          onBlur: input.onBlur,
          items: historicalDataItems,
          selected: input.value || [],
          rightIcon: _icons.IconNames.CARET_DOWN,
          minimal: true,
          multiple: true
        });
      }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "realtimeDataItems",
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditor.realtimeDataItems",
          defaultMessage: "Realtime"
        })
      }, function (_ref6) {
        var input = _ref6.input;
        return /*#__PURE__*/_react["default"].createElement(_DeviceDataItemSelector.DeviceDataItemSelector, {
          placeholder: translate("DeviceDataItemSelector.placeholder.multiple.realtime", "Select Realtime Data Items"),
          onSelect: input.onChange,
          onBlur: input.onBlur,
          items: realtimeDataItems,
          selected: input.value || [],
          rightIcon: _icons.IconNames.CARET_DOWN,
          minimal: true,
          multiple: true
        });
      })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        name: "cycleClassifications",
        label: /*#__PURE__*/_react["default"].createElement("h3", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditor.cycleClassifications",
          defaultMessage: "Cycle Classifications"
        }))
      }, /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "currentCycleClassify",
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditor.currentCycleClassify",
          defaultMessage: "Default Classification for Current Cycle"
        })
      }, function (_ref7) {
        var input = _ref7.input;
        return /*#__PURE__*/_react["default"].createElement(_core.RadioGroup, {
          onChange: input.onChange,
          onBlur: input.onBlur,
          selectedValue: input.value
        }, /*#__PURE__*/_react["default"].createElement(_core.Radio, {
          label: translate("DeviceEditor.currentCycleClassify.radio.entire", "Entire - From Start of Cycle"),
          value: "ENTIRE"
        }), /*#__PURE__*/_react["default"].createElement(_core.Radio, {
          label: translate("DeviceEditor.currentCycleClassify.radio.fromNow", "From Now - From Time of Classification"),
          value: "FROMNOW"
        }));
      }), /*#__PURE__*/_react["default"].createElement(EnabledCheckBoxWrapper, {
        name: "allowProducing",
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditor.allowProducing",
          defaultMessage: "Producing State Classification"
        }),
        type: "checkbox"
      }, function (_ref8) {
        var input = _ref8.input;
        return /*#__PURE__*/_react["default"].createElement(_core.Checkbox, _extends({
          label: "Allow"
        }, input));
      }))));
    });
  };
  return DeviceEditor;
}(_react.Component), _DeviceEditor.defaultProps = {
  translator: undefined,
  dataItems: undefined,
  deviceTags: undefined
}, _DeviceEditor)) || _class) || _class) || _class);